<template>
    <div class="expand-toggle">
        <p>Score de performance</p>
        <button class="primary-button-outlined" @click="expand = !expand"><i class="material-icons">add</i></button>
    </div>
    
    <section class="score-display grid grid-x-5" v-if="props.computer">
        <ProgressCircle :min="targetBench.min_gpu_score" :max="targetBench.max_gpu_score" :value="props.computer?.gpu_score || 'N/A'" allow-overflow-color show-percentage-hint>
            GPU
        </ProgressCircle>
        <ProgressCircle :min="targetBench.min_cpu_score" :max="targetBench.max_cpu_score" :value="props.computer?.cpu_score || 'N/A'" allow-overflow-color show-percentage-hint>
            CPU
        </ProgressCircle>
        <ProgressCircle :min="targetBench.min_memory_score" :max="targetBench.max_memory_score" :value="props.computer?.memory_score || 'N/A'" allow-overflow-color show-percentage-hint>
            Mémoire
        </ProgressCircle>
        <ProgressCircle :min="targetBench.min_storage_score" :max="targetBench.max_storage_score" :value="props.computer?.storage_score || 'N/A'" allow-overflow-color show-percentage-hint>
            Stockage
        </ProgressCircle>
        <ProgressCircle :min="targetBench.min_overall_score" :max="targetBench.max_overall_score" :value="props.computer?.overall_score || 'N/A'" allow-overflow-color show-percentage-hint>
            Score global
        </ProgressCircle>
    </section>
    <div v-else>
        
        <span class="info">Aucun benchmark n'est actuellement disponible pour cet appareil.</span>
    </div>

    <section v-if="expand">
        <p>Score de référence</p>
        <section class="score-display grid grid-x-5">
            <ProgressCircle :min="targetBench.min_gpu_score" :max="targetBench.max_gpu_score" :value="targetBench.gpu_score || 'N/A'" allow-overflow-color>
                GPU
            </ProgressCircle>
            <ProgressCircle :min="targetBench.min_cpu_score" :max="targetBench.max_cpu_score" :value="targetBench.cpu_score || 'N/A'" allow-overflow-color>
                CPU
            </ProgressCircle>
            <ProgressCircle :min="targetBench.min_memory_score" :max="targetBench.max_memory_score" :value="targetBench.memory_score || 'N/A'" allow-overflow-color>
                Mémoire
            </ProgressCircle>
            <ProgressCircle :min="targetBench.min_storage_score" :max="targetBench.max_storage_score" :value="targetBench.storage_score || 'N/A'" allow-overflow-color>
                Stockage
            </ProgressCircle>
            <ProgressCircle :min="targetBench.min_overall_score" :max="targetBench.max_overall_score" :value="targetBench.overall_score || 'N/A'" allow-overflow-color>
                Score global
            </ProgressCircle>
        </section>
    </section>
</template>

<script setup>
    import { onMounted, ref } from 'vue'
    import ProgressCircle     from '@/components/ProgressCircle.vue'
    import apiClient          from '@/api'

    const targetBench = ref({})
    const expand      = ref(false)

    const props = defineProps({
        computer: Object
    })

    const getTargetBenchmark = async () => {
        try {
            const response = await apiClient.get('get_target_benchmark/')
            console.log('Status : ', response.status)
            console.log(response.data.message, response.data.data)
            targetBench.value = response.data.data

        } catch (error) {
            if (error.response) {
                console.log('Status : ', error.response.status)
                console.log(error.response.data.message)
            } else if (error.request) {
                console.log(error.request)
            } else {
                console.log(error.message)
            }
        }
    }

    onMounted(async () => {
        await getTargetBenchmark()
    })
</script>

<style lang="scss" scoped>
.score-display {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    gap: 1rem;
    margin-top: 2rem;
}

.info {
    font-style: italic;
    text-align: center;
    color: gray;
}

.expand-toggle {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    
    width: 100%;

    button {
        padding: .5rem;
    }
}
</style>